import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../context/AdminContext';
import '../pages/AdminDashboard.css';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { admin, logout } = useAdmin();
  const [stats, setStats] = useState({
    categories: 0,
    news: 0,
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await fetch('/api/admin-stats', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('admin_token')}`,
        },
      });
      const data = await response.json();
      setStats(data);
    } catch (err) {
      console.error('Error fetching stats:', err);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="admin-dashboard-container">
      <div className="admin-sidebar">
        <div className="admin-logo">
          <h2>Admin Panel</h2>
        </div>
        <nav className="admin-nav">
          <a href="#/" className="nav-item active">
            📊 Dashboard
          </a>
          <a href="#/categories" onClick={() => navigate('/admin/categories')} className="nav-item">
            📁 Categories
          </a>
          <a href="#/news" onClick={() => navigate('/admin/news')} className="nav-item">
            📰 News
          </a>
          <button onClick={handleLogout} className="nav-item logout-btn">
            🚪 Logout
          </button>
        </nav>
      </div>

      <div className="admin-main">
        <div className="admin-header">
          <h1>Dashboard</h1>
          <div className="admin-user-info">
            <span>Welcome, {admin?.full_name || admin?.email}</span>
          </div>
        </div>

        <div className="dashboard-content">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon">📁</div>
              <div className="stat-info">
                <h3>Categories</h3>
                <p className="stat-value">{stats.categories}</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon">📰</div>
              <div className="stat-info">
                <h3>News Articles</h3>
                <p className="stat-value">{stats.news}</p>
              </div>
            </div>
          </div>

          <div className="quick-actions">
            <h2>Quick Actions</h2>
            <div className="actions-grid">
              <button
                onClick={() => navigate('/admin/categories')}
                className="action-btn"
              >
                <span className="action-icon">➕</span>
                <span className="action-text">Create Category</span>
              </button>
              <button
                onClick={() => navigate('/admin/news')}
                className="action-btn"
              >
                <span className="action-icon">✍️</span>
                <span className="action-text">Create News</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
